import MessageAlert from 'utils';

const reg = {
  /* 아이디/패스워드 */
  // account: /^[a-zA-Z0-9]{4,100}$/,
  account: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{4,20}$/, // 하나 이상 영문자, 숫자 포함. 8자리 이상 20자리 이하
  accountStore: /^[A-Za-z\d_]{2,20}$/, // 하나이상 영문자, _(언더스코어) 가능 20자 이하
  accountEng: /[^a-z|^0-9]/gi,

  sanitize: /[\\/'"`;<>()[\]{}]/g, // 데이터베이스 관련 특수 문자 확인

  password: /^[a-zA-Z0-9]{4,100}$/,

  /* 이름형식 */
  name: /^[\w\Wㄱ-ㅎㅏ-ㅣ가-힣]{2,20}$/,

  /* 텍스트 */
  text: /^[a-zA-Z0-9]{1,255}$/,

  /* 숫자 */
  number: /^[0-9]+$/,

  /* 연락처/일반전화 */
  phone: /^01([0|1|6|7|8|9]?)-?([0-9]{3,4})-?([0-9]{4})$/,
  phone2: /^\d{2,3}-\d{3,4}-\d{4}$/,
  contact: /^\d{2,3}-\d{3,4}-\d{4}$/,

  /* 이메일 */
  email:
    /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i,

  /* 공백체크 */
  isBlank: /\s/g,

  /* 한글 */
  korean: /^[ㄱ-ㅎㅏ-ㅣ가-힣]+$/,

  /* URL */
  url: /^(ftp|http|https):\/\/[^\s/$.?#].[^\s]*$/i,

  /* 스크립트 제거 */
  isScript: '<script[^>]*>(.*?)</script>',
  exchangeScript: (str) => str.replace('<script[^>]*>(.*?)</script>', ''),
};

/**
 * 정규식 검사
 * --
 * @param {string} type
 * @param {*} value
 * @returns
 */
const validateCheck = (type, value) => {
  return reg[type].test(value);
};

/**
 * 패스워드 유효성 검사
 * --
 * NOTE
 * 1. 패스워드는 8자리 이상 20자리 이하여야한다.
 * 2. 패스워드는 패스워드는 영문자, 숫자, 특수문자로 이루어져야한다.
 * 3. 패스워드는 최소 하나 이상의 대문자가 포함되어야한다.
 * 4. 패스워드는 최소 하나 이상의 소문자가 포함되어야한다.
 * 5. 패스워드에 최소 하나 이상의 숫자가 포함되어야 한다.
 * 6. 패스워드에는 최소 하나 이상의 특수문자(@$!%*?&)가 포함되어야한다.
 */
export const passwordCheck = (value, callback = null) => {
  if (value.length < 8 || value.length > 20) {
    MessageAlert.warning(`비밀번호는 8자리 이상 20자리 이하여야 합니다.`);
    callback && callback(`비밀번호는 8자리 이상 20자리 이하여야 합니다.`);
    return false;
  }

  // if (!/(?=.*[A-Z])/.test(value)) {
  //   MessageAlert.warning(
  //     '비밀번호에는 최소 하나 이상의 대문자가 포함되어야 합니다.'
  //   );
  //   callback &&
  //     callback('비밀번호에는 최소 하나 이상의 대문자가 포함되어야 합니다.');
  //   return false;
  // }

  // if (!/(?=.*[a-z])/.test(value)) {
  //   MessageAlert.warning(
  //     '비밀번호에는 최소 하나 이상의 소문자가 포함되어야 합니다.'
  //   );
  //   callback &&
  //     callback('비밀번호에는 최소 하나 이상의 소문자가 포함되어야 합니다.');

  //   return false;
  // }

  if (!/^[A-Za-z0-9!-/:-@[-`{-~]+$/.test(value)) {
    MessageAlert.warning(
      '비밀번호에는 영문자와 숫자, 특수문자만 입력 가능합니다.'
    );
    callback &&
      callback('비밀번호에는 영문자와 숫자, 특수문자만 입력 가능합니다.');

    return false;
  }

  if (!/(?=.*\d)/.test(value)) {
    MessageAlert.warning(
      '비밀번호에는 최소 하나 이상의 숫자가 포함되어야 합니다.'
    );
    callback &&
      callback('비밀번호에는 최소 하나 이상의 숫자가 포함되어야 합니다.');

    return false;
  }

  // if (!/(?=.*[@$!%*?&])/.test(value)) {
  //   MessageAlert.warning(
  //     '비밀번호에는 최소 하나 이상의 특수문자(@$!%*?&)가 포함되어야 합니다.'
  //   );
  //   callback &&
  //     callback(
  //       '비밀번호에는 최소 하나 이상의 특수문자(@$!%*?&)가 포함되어야 합니다.'
  //     );

  //   return false;
  // }

  return true;
};

export default validateCheck;
